// HOME RECOMMENDATIONS *****************************************************************
// pathname: /v1/jobs/recommendations/home
// **************************************************************************************
import { fetcherSwrBase } from '@utils/data-fetching/fetcher';


// Interface
// ********************************************
export type HomeRecommendationsResponse = ApiSchema<'CursorJobResult'>;


/**
 * @description Fetch the top personalised job recommendations for the current user.
 *
 * Backed by `GET /v1/jobs/recommendations/home?limit=N`. The endpoint is per-user
 * cached server-side (60s) and falls back gracefully on the backend if no evaluations
 * exist, so the frontend doesn't need to special-case unauthenticated/anonymous users.
 *
 * @param limit - number of recommendations to fetch; default 3.
 * @param locale - locale for the Accept-Language header; default 'ro'.
 */
export const fetchHomeRecommendations = (limit = 3, locale = 'ro'): Promise<HomeRecommendationsResponse> => (
  fetcherSwrBase<HomeRecommendationsResponse>(
    `/v1/jobs/recommendations/home?limit=${limit}`,
    locale,
    {},
  )
);
